import { CREATE_AFFIARS_OF_SURGERY_FAIL, CREATE_AFFIARS_OF_SURGERY_REQUEST, CREATE_AFFIARS_OF_SURGERY_SUCCESS, UPDATE_AFFIARS_OF_SURGERY_FAIL, UPDATE_AFFIARS_OF_SURGERY_REQUEST, UPDATE_AFFIARS_OF_SURGERY_SUCCESS } from "../../ActionType/AffiarsOfSurgeryTypes/AffiarsOfSurgeryTypes";


export const createAffiarsOfSurgeryReducer = (
    state = { loading: true, affiars: [], error: "" },
    action
  ) => {
    switch (action.type) {
      case CREATE_AFFIARS_OF_SURGERY_REQUEST:
        return {
          loading: true,
          affiars:action.payload
        };
      case CREATE_AFFIARS_OF_SURGERY_SUCCESS:
        return {
          loading: false,
          affiars:action.payload,
          error:"",
        };
      case CREATE_AFFIARS_OF_SURGERY_FAIL:
        return {
          loading: false,
          branches:action.payload,
          error:"",
        };
      default:
        return state;
    }
  };
  
  export const updateAffiarsOfSurgeryReducer = (
    state = { loading: true, affiars: [], error: "" },
    action
  ) => {
    switch (action.type) {
      case UPDATE_AFFIARS_OF_SURGERY_REQUEST:
        return {
          loading: true,
          affiars:action.payload
        };
      case UPDATE_AFFIARS_OF_SURGERY_SUCCESS:
        return {
          loading: false,
          affiars:action.payload,
          error:"",
        };
      case UPDATE_AFFIARS_OF_SURGERY_FAIL:
        return {
          loading: false,
          branches:action.payload,
          error:"",
        };
      default:
        return state;
    }
  };
  
  